/** @jsxImportSource @emotion/react */
import PropTypes from "prop-types";
import pageHeaderCss from "components/common/PageHeader/index.css";
import { rowGap24Css } from "assets/css/gaps.css";
import PageSection from "components/PageSection";
import { buttonCss, pageHeaderContainerCss } from "./index.css";

export default function Layout({ children, handleCreateReport }) {
  return (
    <div className="container">
      <div className="flex-column" css={rowGap24Css}>
        <PageSection css={pageHeaderContainerCss}>
          <h1 css={pageHeaderCss.header} className="main-title">
            Scheduled Reports
          </h1>
        </PageSection>

        {children}
        <button type="button" onClick={handleCreateReport} css={buttonCss}>
          Create Report
        </button>
      </div>
    </div>
  );
}

Layout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  handleCreateReport: PropTypes.func.isRequired,
};
